var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 0C12.9839 0 0 12.9839 0 29C0 42.5998 9.36352 54.0119 21.9948 57.1462V37.8624H16.015V29H21.9948V25.1813C21.9948 15.3108 26.4619 10.7358 36.1526 10.7358C37.99 10.7358 41.1603 11.0966 42.4572 11.4562V19.4892C41.7728 19.4172 40.5838 19.3813 39.1071 19.3813C34.3522 19.3813 32.5148 21.1828 32.5148 25.8657V29H41.9874L40.3599 37.8624H32.5148V57.7877C46.8744 56.0535 58.0012 43.8271 58.0012 29C58 12.9839 45.0161 0 29 0Z",
    fill: "#C8B690"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f7a9f084502c45dd9e3263c62b7c3cd0.svg";
export { ForwardRef as ReactComponent };